// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import constants from "@store/constants";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC } from "react";

export interface ReportHeaderProps extends WidgetProps {}

export interface ReportHeaderStyles {}

export const reportHeaderStyles: ReportHeaderStyles = {};

const styles = reportHeaderStyles;

const ReportHeader: FC<ReportHeaderProps> = ({ id }) => {
    const currentPage = useCurrentPage();
    const linkBack = usePageLinkByPageType(constants.pageType.myReports);

    return (
        <OrderHeader title={currentPage.fields.title} linkBack={linkBack}>
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: ReportHeader,
    definition: {
        group: constants.widgetGroup.report,
        displayName: "Header",
        allowedContexts: [constants.pageType.report],
    },
};

export default widgetModule;
